export default __webpack_public_path__ + "static/media/logo192x192.e06cccf1.png";